import api from "app/api";
import { Permissions } from "app/constants";
import useAccess from "features/profile/useAccess";
import { useEffect, useState } from "react";

export default function useNotifyCount() {
  const [count, setCount] = useState(0);
  const { hasPermissions } = useAccess();
  const canViewNotifications = hasPermissions(Permissions.BookingNotify);

  useEffect(() => {
    if (!canViewNotifications) {
      setCount(0);
      return;
    }

    async function loadNotifyCount() {
      const { success, data } = await api.get("/bookings/notify-count");
      if (success) {
        setCount(data?.count || 0);
      }
    }

    loadNotifyCount();
  }, [canViewNotifications]);

  return count;
}
